import React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";

const Popup = (props) => {
  const {
    clickAction,
    handleClose,
    open,
    question,
    text,
    text2,
    child,
    title,
  } = props;

  const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
      padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
      padding: theme.spacing(1),
    },
  }));

  const BootstrapDialogTitle = (props) => {
    const { children, onClose, ...other } = props;

    return (
      <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
        {children}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
    );
  };

  // const handleClickOpen = () => {
  //   setOpen(true);
  // };
  // const handleClose = () => {
  //   setOpen(false);
  // };

  return (
    <div>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={handleClose}
        >
          {title}
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <DialogTitle className="spanQuestion">{question}</DialogTitle>
          <Typography gutterBottom className="spanQuestion">
            {text}
          </Typography>
          <Typography gutterBottom>{text2}</Typography>

          {child}
        </DialogContent>
        <DialogActions>
          <Button
            type="button"
            className="button-pay"
            autoFocus
            onClick={clickAction}
          >
            Aceptar
          </Button>

          <Button autoFocus className="button-delete" onClick={handleClose}>
            Cancelar
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
};
export { Popup };
export default Popup;
